module.exports = __webpack_public_path__ + "b2bMeta.6303c301405be586fb33c32c1562ee12.png";